import React, { useState,useEffect } from 'react';
import { formatDate } from './Function';
import { useTranslation } from 'react-i18next';
import { Row,Col,Card,Placeholder,ListGroup } from 'react-bootstrap';
const HostelEvents = ({mtId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneousType(result);
                    }).catch(error => {
                        console.error('MiscellaneousType Image :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousType();
    },[mtId])
    return (
        <React.Fragment>
            {isLoading ? ( 
                <Card className='mb-4'>
                    <Card.Header className='text-center fs-3 text-uppercase'><Placeholder xs={10} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            {[...Array(12)].map((_,index)=>(
                            <Col md={3} key={index} >
                                <div className="bg-info text-center p-3 bg-opacity-25 border border-dark border-3 h-100" data-aos="flip-up" data-aos-duration="1500">
                                    <h4><Placeholder xs={8} /></h4>
                                    <div><Placeholder xs={6} /></div>
                                </div>
                            </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ) : (
                <React.Fragment>
                {MiscellaneousType.map((mt,index)=>(
                <Card className='text-center mb-4' key={index}>
                    <Card.Header className='text-center fs-3 text-uppercase'>
                        {appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_name_hi || '' : mt.mt_name_hi || mt.mt_name) : mt.mt_name}
                    </Card.Header>
                    <Card.Body>
                        <p>{appLanguage === 'hi' ? 'छात्रावास में विभिन्न अवसरों पर विभिन्न कार्यक्रम आयोजित किए जाते हैं। इनमें से कुछ कार्यक्रम इस प्रकार हैं:' : 'Various events are obtained in the Hostel on different occasion. Few of the events are as below:'}</p>
                        <MiscellaneousList mtId={mt.mt_id} mtImage={appLanguage === 'hi' ? mt.miscImage_hi || mt.miscImage : mt.miscImage} />
                    </Card.Body>
                </Card>
                ))}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
export default HostelEvents;
const MiscellaneousList = ({mtId,mtImage}) => 
{
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[UpcomingEvents,setUpcomingEvents]=useState([]);
    const[PastEvents,setPastEvents]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                setUpcomingEvents(result.filter(event => event.sm_date > Math.floor(Date.now() / 1000)));
                setPastEvents(result.filter(event => event.sm_date < Math.floor(Date.now() / 1000)));
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousByType();   
    },[mtId,mtImage])
    return (
        <Row className='g-3'>
            <Col md={6}>
                <Card className='shadow h-100'>
                    <h4 className='my-2'>{appLanguage === 'hi' ? 'आगामी कार्यक्रम' : 'Upcoming Events'}</h4>
                    <span className="mx-auto mb-0 sub-heading"></span>
                    {isLoading ? (
                        <Card.Body>
                        {[...Array(10)].map((_,index) => (
                            <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                    <i className="bi bi-calendar3"></i>
                                </span>
                                <div>
                                    <Placeholder xs={12} />
                                    <Placeholder xs={6} bg="secondary" />
                                </div>
                            </ListGroup.Item>
                        ))}
                        </Card.Body>
                    ) : (
                        <React.Fragment>
                        {UpcomingEvents.length === 0 ? (
                            <Card.Body>
                                <big>{t('NoResult')}</big>
                            </Card.Body>
                        ) : (
                            <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"400px"}}>
                                <ListGroup variant="flush">
                                {UpcomingEvents.map((sm,index)=>(
                                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                            <i className="bi bi-calendar3"></i>
                                        </span>
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name }}></div>
                                            <div className='text-secondary'>{formatDate(sm.sm_date)}</div>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                                </ListGroup>
                            </Card.Body>                                  
                        )}
                        </React.Fragment>
                    )}                        
                </Card>
            </Col>
            <Col md={6}>
                <Card className='shadow h-100'>
                    <h4 className='my-2'>{appLanguage === 'hi' ? 'विगत कार्यक्रम' : 'Past Events'}</h4>
                    <span className="mx-auto mb-0 sub-heading"></span>
                    {isLoading ? (
                        <Card.Body>
                        {[...Array(10)].map((_,index) => (
                            <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                    <i className="bi bi-calendar-check-fill"></i>
                                </span>
                                <div>
                                    <Placeholder xs={12} />
                                    <Placeholder xs={6} bg="secondary" />
                                </div>
                            </ListGroup.Item>
                        ))}
                        </Card.Body>
                    ) : (
                        <React.Fragment>
                        {PastEvents.length === 0 ? (
                            <Card.Body>
                                <big>{t('NoResult')}</big>
                            </Card.Body>
                        ) : (
                            <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"400px"}}>
                                <ListGroup variant="flush">
                                {PastEvents.map((sm,index)=>(
                                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                            <i className="bi bi-calendar-check-fill"></i>
                                        </span>
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name }}></div>
                                            <div className='text-secondary'>{formatDate(sm.sm_date)}</div>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                                </ListGroup>
                            </Card.Body>                                  
                        )}
                        </React.Fragment>
                    )}                        
                </Card>
            </Col>
        </Row>
    );
}